import React from "react"
import { FounderContainer, FounderWrapper, FounderImage, Image, FounderText,
FounderHead, FounderP, FounderPP } from "./FounderElement"
import img from "../../Images/f.png"

const Founder = () =>{
    return(
        <FounderContainer>
            
        <FounderWrapper>
            <FounderImage data-aos="fade-right">
                <Image src={img} alt="founder"/>
                </FounderImage>

                <FounderText data-aos="fade-left">
                    
                    <FounderP>Dr. Collins Paul(Phd)</FounderP>
                    <FounderHead>Chairman/Founder</FounderHead>
                    <FounderPP> Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimusLorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimusLorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimusLorem ipsum, dolor sit amet consectetur adipisicing elit. 
                Aliquam enim iure alias nulla mollitia soluta hic distinctio
                 corporis aspernatur possimus</FounderPP>
                </FounderText>
        </FounderWrapper>
        </FounderContainer>
    )


}

export default Founder